import axios from "axios";
import config from "../../config";





export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        users: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        userMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {


        getUsersRequest({dispatch}) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveUsers", null);
            } else {
                dispatch("receivingUsers"); // สถานะ กำลังบันทึก

                axios.get('/mem_users').then(res => {
                    dispatch("receiveUsers", res.data);
                    console.log(res.data)
                })
                    .catch((e) => {
                        console.log(e)
                        dispatch("receiveUsers", null);
                    })
            }
        },
        loadUserRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveUser", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingUser");
                axios.get('/mem_users/' + id).then(res => {
                    dispatch("receiveUser", res.data);
                })
            }
        },
        updateUserRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingUser");
            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('file_fi', payload.avatarFileFi);
            formData.append('id', payload.id);
            formData.append('user_name', payload.user_name);
            formData.append('email', payload.email);
            formData.append('fname_th', payload.fname_th);
            formData.append('lname_th', payload.lname_th);
            formData.append('fname_en', payload.fname_en);
            formData.append('lname_en', payload.lname_en);
            formData.append('disabled', payload.disabled);

            formData.append('info_id', payload.info_id);
            formData.append('prefix_code', payload.prefix_code);
            formData.append('info_email', payload.info_email);
            formData.append('info_mobile', payload.info_mobile);
            formData.append('info_tel', payload.info_tel);
            formData.append('info_room', payload.info_room);
            formData.append('info_data_a', payload.info_data_a);
            formData.append('info_data_b', payload.info_data_b);
            formData.append('info_data_c', payload.info_data_c);
            formData.append('info_data_d', payload.info_data_d);
            formData.append('info_expert_th', payload.info_expert_th);
            formData.append('info_expert_en', payload.info_expert_en);
            formData.append('info_cv_link', payload.info_cv_link);
            formData.append('info_link_a', payload.info_link_a);
            formData.append('info_h_file', payload.info_h_file);
            axios.post('/update_mem_users', formData).then(res => {
                dispatch("updateUser", res.data);
                console.log(res)
            })
        },
        createUserRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingUser");

            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('file_fi', payload.avatarFileFi);
            formData.append('user_name', payload.user_name);
            formData.append('email', payload.email);
            formData.append('fname_th', payload.fname_th);
            formData.append('lname_th', payload.lname_th);
            formData.append('fname_en', payload.fname_en);
            formData.append('lname_en', payload.lname_en);
            formData.append('disabled', payload.disabled);

            formData.append('info_id', payload.info_id);
            formData.append('prefix_code', payload.prefix_code);
            formData.append('info_email', payload.info_email);
            formData.append('info_mobile', payload.info_mobile);
            formData.append('info_tel', payload.info_tel);
            formData.append('info_room', payload.info_room);
            formData.append('info_data_a', payload.info_data_a);
            formData.append('info_data_b', payload.info_data_b);
            formData.append('info_data_c', payload.info_data_c);
            formData.append('info_data_d', payload.info_data_d);
            formData.append('info_expert_th', payload.info_expert_th);
            formData.append('info_expert_en', payload.info_expert_en);
            formData.append('info_cv_link', payload.info_cv_link);
            formData.append('info_link_a', payload.info_link_a);
            formData.append('info_h_file', payload.info_h_file);
            // formData.append('info_link_b', payload.info_link_b);
            // formData.append('info_link_c', payload.info_link_c);
            // formData.append('info_link_d', payload.info_link_d);
            // formData.append('info_link_f', payload.info_link_f);
            // formData.append('info_link_g', payload.info_link_g);


            axios.post('/mem_users', formData).then(res => {
                dispatch("receiveUser", res.data);

            })
        },
        deleteUserRequest({dispatch}, payload) {

            console.log(payload)

            dispatch("afterDeleteUser", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingUser", payload);

            axios.post('/delete_mem_users', payload).then(res => {
                dispatch("deleteUser", {id: payload.id, res: res});
            })


        },
        receiveUsers({commit}, payload) {
            commit("RECEIVED_USERS", payload)
        },
        receivingUsers({commit}) {
            commit("RECEIVING_USERS") //call matutions --> state.isReceiving = true;
        },
        receiveUser({commit}, payload) {
            commit("RECEIVED_USER", payload)
        },
        receivingUser({commit}) {
            commit("RECEIVING_USERS") //call matutions --> state.isReceiving = true;
        },
        updateUser({commit}, payload) {
            commit("UPDATED_USER", payload)
        },
        updatingUser({commit}) {
            commit("UPDATING_USER") //  call matutions --> state.isUpdating = true;
        },
        deleteUser({commit}, payload) {
            commit("DELETED_USER", payload)
        },
        deletingUser({commit}, payload) {
            commit("DELETING_USER", payload)
        },
        afterDeleteUser({commit}, payload) {
            commit("AFFTER_DELETED_USER", payload)
        },


    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_USERS(state, payload) {
            state.users = payload;
            state.isReceiving = false;

        },
        RECEIVING_USERS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_USER(state, payload) {


            if (payload.id == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let userMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),

                });
            } else {

                let userMessage = 'บันทึกสำเร็จ! รายการ ' + payload.email + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    users: [...state.users, payload],
                    isReceiving: false,
                    errorMessage: false,
                    userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_USER(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_USER(state, payload) {

            let index = state.users.findIndex(p => p.id === payload.id);
            let userMessage = 'บันทึกสำเร็จ! รายการ ' + payload.email + ' ถูกแก้ไขแล้ว';

            state = Object.assign(state, {
                users: state.users.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),
            })
        },
        UPDATING_USER(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_USER(state, payload) {


            if (payload.id == undefined || payload.res.data.message == 'Relation') {
                let userMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.email;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),

                });
            } else {
                let indexToDelete = state.users.findIndex(p => p.id === payload.id);
                let users = [...state.users];
                users.splice(indexToDelete, 1);
                let userMessage = 'บันทึกสำเร็จ! รายการ ' + payload.email + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    users: [...users],
                    isDeleting: false,
                    idToDelete: null,
                    userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_USER(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.id;
        },
        AFFTER_DELETED_USER(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
